const type = 'SET_RECHARGE_SUBMITTING';

const setRechargeSubmitting = (data) => ({
  data,
  type,
});

export { type };
export default setRechargeSubmitting;
